<template>
  <div :class="{ hasAnswer: answer }" class="media-and-preview">
    <button @click="openModalMedia" v-if="!locked">
      <span class="media-icon"><Media /> </span>

      <span v-if="!mediaName">{{ parseTranslation(UPLOAD) }}</span>
      <span v-else :title="mediaName">{{ mediaName | formatName }}</span>
    </button>
    <button
      v-if="!answer"
      @click="openModalPreview(owQuestionsTestLink, code)"
      style="color: #0695fd"
    >
      <img src="@/assets/imgs/preview-icon.svg" alt="Preview Icon" />
      {{ parseTranslation(PREVIEW) }}
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Media from '@/components/imgs/Media'

import { removeUndefinedProperties } from '@/utils/object'

import * as translationModalMedia from './MediaModal.translations'

const { default: translations, ...translationKeys } = translationModalMedia

export default {
  components: { Media },

  props: {
    question: {
      required: true,
    },
    answer: {
      default: null,
    },
    alternativeName: {
      default: null,
    },
    mediaId: {
      required: true,
    },
    locked: {
      default: false,
    },
    code: {
      default: null,
      required: true,
    },
    saveSurvey: {
      required: true,
    },
  },

  filters: {
    formatName(name) {
      if (name.length > 5) return `${name.substring(0, 5)}...`
      return name
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      mediaName: null,
    }
  },

  computed: {
    mediaObj() {
      return this.$store.getters.mediaObj
    },
    deleteMedia() {
      return this.$store.getters.deleteMedia
    },
  },

  watch: {
    mediaObj() {
      if (this.mediaObj && this.mediaObj.mediaId === this.mediaId) {
        this.mediaName = this.getMediaName(this.mediaObj.url)
      }
    },

    deleteMedia() {
      if (this.deleteMedia && this.deleteMedia.mediaId === this.mediaId) {
        this.mediaName = null
      }
    },

    answer() {
      if (!this.answer?.media) {
        this.mediaName = null
      }
    },
  },

  methods: {
    ...mapActions(['modalMedia', 'preview', 'surveyRegister', 'sendMessage']),

    openModalMedia() {
      const obj = {
        media: this.answer ? this.answer?.media : this.question?.media,
        question: this.question,
        sid: this.$store.getters.survey.id_,
        mediaId: this.mediaId,
        answer: this.answer || undefined,
        addLabelOption: !!this.answer,
        alternativeName: this.alternativeName || null,
      }

      this.modalMedia(removeUndefinedProperties(obj))
    },

    async openModalPreview(owQuestions, code) {
      await this.saveSurvey()

      this.preview({
        owQuestions,
        code,
      })
    },

    getMediaName(s3MediaURL) {
      const [name] = s3MediaURL.split('/').reverse()

      return name
    },
  },

  created() {
    if (!this.answer && this.question?.media) {
      this.mediaName = this.getMediaName(this.question.media.url)
    } else if (this.answer?.media) {
      this.mediaName = this.getMediaName(this.answer.media.url)
    }
  },
}
</script>

<style lang="scss" scoped>
.media-and-preview {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 10px 0 0;
  &.hasAnswer {
    margin: 0;
    button {
      &:nth-of-type(1) {
        white-space: nowrap;
      }
    }
  }
  button {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    @include tipography(16);
    text-decoration: underline;
    cursor: pointer;

    img {
      margin-right: 5px;
    }

    .media-icon {
      display: flex;
      align-items: center;
    }

    svg {
      @include boxSizing(25);
      margin-right: 5px;
    }

    &:nth-of-type(1) {
      margin-right: 10px;
      color: $white;
    }

    &:nth-of-type(2) {
      color: $blue;
    }

    &.active {
      color: $blue;
    }

    .light & {
      &:nth-of-type(1) {
        color: $gray-2;
      }
    }
  }
}
</style>
